import React from "react";
import { Box, Button, Container, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const OrderNotFound = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="sm">
      <Helmet>
        <title>Order Not Found</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          textAlign: "center",
          py: 4,
        }}
      >
        <Typography variant="h1" sx={{ fontSize: "8rem", fontWeight: "bold", color: "primary.main" }}>
          404
        </Typography>
        <Typography variant="h4" sx={{ mb: 2, fontWeight: "bold" }}>
          Order Not Found
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: "text.secondary" }}>
          The order you're looking for doesn't exist or may have been removed.
          Please check your order details and try again.
        </Typography>
        <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", justifyContent: "center" }}>
          <Button
            variant="contained"
            onClick={() => navigate("/")}
            sx={{ minWidth: 120 }}
          >
            Go Home
          </Button>
          <Button
            variant="outlined"
            onClick={() => navigate(-1)}
            sx={{ minWidth: 120 }}
          >
            Go Back
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default OrderNotFound;
